<template>
  <v-app>
    <v-main id="complete" :class="{ 'white-bg': $vuetify.breakpoint.smAndDown }">
      <v-container fluid>
        <v-row justify="center" class="mt-9">
          <Logo />
        </v-row>
        <v-row justify="center">
          <v-col cols="12" xs="12" md="4" style="max-width: 400px;">
            <v-card class="card px-2 py-0 elevation-0">
              <v-card-text class="pa-7" :class="{ 'pt-1': $vuetify.breakpoint.smAndDown }">
                <SignError :error="error" />

                <div
                  class="card-title pb-5"
                  :class="{
                    'white--text': $vuetify.theme.dark,
                    'darkTextGrey--text': !$vuetify.theme.dark,
                  }"
                >
                  <p v-if="isForgotReturn">{{ $t(`views.forgotReturn.title`) }}</p>
                  <p v-if="isVerificationReturn && !error && !loading">
                    {{ $t(`views.signup.verificationReturn.title`) }}
                  </p>
                </div>
                <div v-if="isVerificationReturn" class="card-subtitle pb-5">
                  <p v-if="isVerificationReturn && !error && !loading">
                    {{ $t(`views.signup.verificationReturn.subtitle`) }}
                  </p>
                </div>

                <v-form @submit.prevent="submit">
                  <v-text-field
                    v-if="isForgotReturn"
                    id="password"
                    v-model="password"
                    :label="$t('views.login.password.label')"
                    name="password"
                    :placeholder="$t('views.login.password.placeholder')"
                    type="password"
                    :disabled="loading"
                  />
                  <v-text-field
                    v-if="isForgotReturn"
                    id="repeat-password"
                    v-model="repeatPassword"
                    :label="$t('views.forgotReturn.repeatPassword.label')"
                    :placeholder="$t('views.forgotReturn.repeatPassword.placeholder')"
                    name="repeatPassword"
                    type="password"
                    :disabled="loading"
                  />
                  <div>
                    <v-btn
                      v-if="isForgotReturn"
                      type="submit"
                      color="primary"
                      :loading="loading"
                      :disabled="submitDisabled"
                      class="submit-button elevation-0 mt-2"
                    >
                      <span v-if="isForgotReturn">{{ $t('views.forgotReturn.continue') }}</span>
                    </v-btn>
                  </div>
                </v-form>
                <div class="links mt-7">
                  <v-divider class="pt-4"></v-divider>
                  <a @click="!loading && $router.replace({ name: 'login' })">
                    {{ $t('views.forgot.goLogin') }}
                  </a>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-0">
          <LanguageSelector />
        </v-row>
        <v-row justify="center" class="my-5 mr-2">
          <ThemeSelector />
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import SignMixin from '@/views/components/sign/signMixin.js'
import SignError from '@/views/components/sign/SignError'
import firebase from 'firebase/app'
import { mapState } from 'vuex'

export default {
  components: { SignError },
  mixins: [SignMixin],
  data: () => ({
    password: null,
    repeatPassword: null,
  }),
  computed: {
    ...mapState(['language']),
    isForgotReturn() {
      return this.$route.query.mode === 'resetPassword' && !!this.$route.query.oobCode
    },
    isVerificationReturn() {
      return this.$route.query.mode === 'verifyEmail' && !!this.$route.query.oobCode
    },
    submitDisabled() {
      if (this.isForgotReturn) return !this.password || !this.repeatPassword
      return false
    },
  },
  created() {
    if (this.isVerificationReturn) this.confirmVerification()
  },
  methods: {
    async confirmVerification() {
      try {
        this.loading = true
        await firebase.auth().applyActionCode(this.$route.query.oobCode)
      } catch (error) {
        this.error = error.code
      }
      this.loading = false
    },
    async submit() {
      if (this.isForgotReturn) return this.resetPassword()
    },
    async resetPassword() {
      if (this.password !== this.repeatPassword) {
        this.error = 'errorRepeat'
        return
      }
      try {
        this.loading = true
        await firebase.auth().confirmPasswordReset(this.$route.query.oobCode, this.password)
        this.setSignMessage({ signMessage: 'passwordReset' })
        this.$router.replace({
          name: 'login',
        })
      } catch (error) {
        this.error = error.code
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
.white-bg {
  background-color: white !important;
}
.theme--dark {
  .white-bg {
    background-color: #1e1e1e !important;
  }
}
#complete {
  // background: #f9fafc;
  .card {
    text-align: center;
    .card-error {
      font-size: 14px;
      font-weight: 300;
    }
    .card-title {
      font-size: 20px;
      font-weight: 300;
    }
    .card-subtitle {
      font-size: 15px;
      font-weight: 300;
    }
    .submit-button {
      width: 100%;
    }
    .links {
      font-size: 14px;
      font-weight: 300;
    }
  }
}
.theme--dark {
  #complete {
    hr {
      border-color: #a5a5a5;
    }
  }
}
</style>
